import React from 'react';
import superagent from 'superagent';

import Messages from '../Util/Messages.jsx';

import { Container, Menu, Segment, Grid, Header, Image, Icon, Button, Form, Divider } from 'semantic-ui-react'

export default class Logout extends React.Component {
    async componentDidMount() {
        try {
            const res = await superagent.get('/api/auth/logout');
            window.location.href = '/';
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        return <div />
    }
}
